import { render, staticRenderFns } from "./category-mapping.vue?vue&type=template&id=249af678&scoped=true"
import script from "./category-mapping.vue?vue&type=script&lang=js"
export * from "./category-mapping.vue?vue&type=script&lang=js"
import style0 from "./category-mapping.vue?vue&type=style&index=0&id=249af678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249af678",
  null
  
)

export default component.exports